/**
 * @generated SignedSource<<cc118fd4e3357c2e1ffeecf56cb971c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ReuseQuestionsCreateDraftMutation$variables = {
  feedbackId: string;
  title: string;
  useSubject: boolean;
};
export type ReuseQuestionsCreateDraftMutation$data = {
  readonly createDraftFromFeedback: {
    readonly feedback: {
      readonly id: string;
      readonly info: any;
    };
  } | null;
};
export type ReuseQuestionsCreateDraftMutation = {
  response: ReuseQuestionsCreateDraftMutation$data;
  variables: ReuseQuestionsCreateDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "feedbackId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "title"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "useSubject"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "feedbackId",
        "variableName": "feedbackId"
      },
      {
        "kind": "Variable",
        "name": "title",
        "variableName": "title"
      },
      {
        "kind": "Variable",
        "name": "useSubject",
        "variableName": "useSubject"
      }
    ],
    "concreteType": "CreateDraftFromFeedback",
    "kind": "LinkedField",
    "name": "createDraftFromFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "FeedbackNode",
        "kind": "LinkedField",
        "name": "feedback",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "info",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReuseQuestionsCreateDraftMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReuseQuestionsCreateDraftMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f6c0a2c7195c53be64b9ba03a8017f0a",
    "id": null,
    "metadata": {},
    "name": "ReuseQuestionsCreateDraftMutation",
    "operationKind": "mutation",
    "text": "mutation ReuseQuestionsCreateDraftMutation(\n  $feedbackId: ID!\n  $title: String!\n  $useSubject: Boolean!\n) {\n  createDraftFromFeedback(feedbackId: $feedbackId, title: $title, useSubject: $useSubject) {\n    feedback {\n      id\n      info\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a83c6683d49cec7345505d0f65676f43";

export default node;
